const teamData = [
    {
        id: 1,
        name: "Bharat Sharma",
        profile: "Software Engineer",
        linkLink: "genu05",
        linkFace: "bharat.sharma.779857",
        offers: [
            "Zynga",
        ]
    },
    {
        id: 2,
        name: "Divyansh Verma",
        profile: "Software Engineer",
        linkLink: "saikunocoda",
        linkFace: "failedcoder",
        offers: [
            "Google",
            "Myntra",
            "Samsung R&D"
        ]
    },
    {
        id: 3,
        name: "Vichitr",
        profile: "Software Engineer",
        linkLink: "vichitrgandas",
        linkFace: "vichitrgandas",
        offers: [
            "Amazon",
            "Visa",
            "Samsung Semiconductor"
        ]
    }
];

export default teamData;
